import _styled from "styled-components";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { hasItems } from "~/features/app/utils";
import { FooterAdditionalLink } from "~/features/app/landing-footer/footer-additional-links/footer-additional-link";
const fragment = graphql(`
  fragment LandingFooterAdditionalLinks on footerAdditionalLinks_NeoField {
    ...LandingFooterAdditionalLink
  }
`);
type Props = {
  links: FragmentType<typeof fragment>[];
};
export function FooterAdditionalLinks(props: Props) {
  const {
    links: _links
  } = props;
  const links = useFragment(fragment, _links);
  if (!hasItems(links)) {
    return null;
  }
  return <_StyledUl>
      {links.map((link, idx) => <li key={idx}>
          <FooterAdditionalLink {...link} />
        </li>)}
    </_StyledUl>;
}
var _StyledUl = /*#__PURE__*/_styled("ul").withConfig({
  displayName: "footer-additional-links___StyledUl",
  componentId: "sc-1bhrr8k-0"
})({
  "display": "flex",
  "flexWrap": "wrap",
  "gap": "4rem"
});